import { MainLoader, ResourceLoader } from 'ia-react-core';
import { TechnicalErrorPage } from 'omni-package-react-core';
import React, { FC, ReactNode, useCallback } from 'react';
import transformFactorsRequest from './transformFactorsRequest';
import { MfaChallenge } from '../../../../interfaces/MfaChallenge';

export interface PostFactorsProps {
  children: ReactNode;
  url: string;
  emailChallenge: MfaChallenge;
  smsChallenge: MfaChallenge;
  onConfirmFactorCalled: () => void;
  startPath?: string;
}

const PostFactors: FC<PostFactorsProps> = ({ children, url, emailChallenge, smsChallenge, startPath, onConfirmFactorCalled }) => {
  const CustomDataErrorMessage = useCallback(() => <TechnicalErrorPage redirectUrl={startPath} />, [startPath]);

  return (
    <ResourceLoader
      method="POST"
      name="resources.confirmFactors"
      url={url}
      transformRequest={() => transformFactorsRequest(emailChallenge, smsChallenge)}
      onSuccess={() => onConfirmFactorCalled()}
      CustomLoader={MainLoader}
      CustomDataErrorMessage={CustomDataErrorMessage}
    >
      {children}
    </ResourceLoader>
  );
};

export default PostFactors;
